import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!url || !key) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY')
}

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    // Prevent lock contention from multiple tabs / React Strict Mode
    lock: async (name, _acquireTimeout, fn) => {
      if (typeof navigator !== 'undefined' && navigator.locks) {
        return navigator.locks.request(name, fn)
      }
      return fn()
    },
  },
})
